import React from "react";
import Home from "../pages/Home";
import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/hestia/home",
            component: (
                <Home history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        }
    ]
};

export default routes;